import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import GoogleSignInPlugin from 'vue3-google-signin';
import { createI18n } from 'vue-i18n';
import * as bootstrap from 'bootstrap';
import App from './App.vue';
import router from './router';
import { useUserStore } from './stores/userStore';
import { getLocale } from './api/api';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);

const userStore = useUserStore();
const savedLang = userStore.lang || navigator.language.split('-')[0] || 'en';
const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: 'en',
  messages: {},
});

function loadLocaleMessages(locale) {
  return getLocale(locale);
}

library.add(fas, fab);
config.familyDefault = 'classic';
config.styleDefault = 'duotone';
window.bootstrap = bootstrap;

app.use(i18n)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(router)
  .use(GoogleSignInPlugin, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  });

loadLocaleMessages(savedLang).then((messages) => {
  i18n.global.setLocaleMessage(savedLang, messages);
  i18n.global.locale.value = savedLang;
  app.mount('#app');
});
